(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('error', (event) => {
    const image = event.target;

    if (!(image instanceof HTMLImageElement) || !image.classList.contains('js-collection-banner-image')) return;

    if (image.dataset.bannerRetryAttempted === 'true') {
      image.hidden = true;
      return;
    }

    image.dataset.bannerRetryAttempted = 'true';

    const retryUrl = new URL(image.currentSrc || image.src, window.location.href);
    retryUrl.searchParams.set('banner_retry', Date.now().toString());

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = retryUrl.href;
  }, true);

  } catch(e) { console.error(e); }
})();
})();
